/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SymptomAttribute from './symptom-attribute';
import SymptomAttributeDetail from './symptom-attribute-detail';
import SymptomAttributeUpdate from './symptom-attribute-update';
import SymptomAttributeDeleteDialog from './symptom-attribute-delete-dialog';

const SymptomAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SymptomAttribute />} />
    <Route path="new" element={<SymptomAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<SymptomAttributeDetail />} />
      <Route path="edit" element={<SymptomAttributeUpdate />} />
      <Route path="delete" element={<SymptomAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SymptomAttributeRoutes;
